import React, { useMemo } from 'react'
import { createBehavior, createResource } from '@designable/core'
import { createForm } from '@formily/core'
import { observer } from '@formily/react'
import { Form as FormilyForm } from '@formily/antd'
import { usePrefix, DnFC } from '@designable/react'
import { AllSchemas } from '../../schemas'
import { AllLocales } from '../../locales'
import { ConfigProvider } from 'antd'
import './styles.less'
import { useEffect } from 'react'

interface IFormProps  {
  theme?: any
}

export const Form: DnFC<React.ComponentProps<typeof FormilyForm> & IFormProps> = observer(
  (props) => {
    // console.log(props)
    const theme = props.theme || {}
    const prefix = usePrefix('designable-form')
    useEffect(() => {
      ConfigProvider.config({
        prefixCls: 'custom',
        theme: {
          ...theme,
        },
      });
    }, [theme.primaryColor, theme.errorColor, theme.warningColor, theme.successColor, theme.textColor])
    const form = useMemo(
      () =>
        createForm({
          designable: true,
        }),
      []
    )
    return (
      <ConfigProvider prefixCls='custom'>
      
        <FormilyForm
          {...props}
          style={{ ...props.style }}
          className={prefix}
          form={form}
        >
          {props.children}
        </FormilyForm>
      </ConfigProvider>
    )
  }
)

Form.Behavior = createBehavior({
  name: 'Form',
  selector: (node) => node.componentName === 'Form',
  designerProps(node) {
    return {
      draggable: !node.isRoot,
      cloneable: !node.isRoot,
      deletable: !node.isRoot,
      droppable: true,
      propsSchema: {
        type: 'object',
        properties: {
          'layout-group': {
            type: 'void',
            'x-component': 'FormTab',
            "x-component-props": { 
              centered: true,
              animated: true,
              className: "formily-tab-centered",
            },
            properties: {
              "theme-group": {
                type: 'void',
                'x-component': 'FormTab.TabPane',
                'x-component-props': {
                  tab: '页面配置',
                },
                properties: {
                  theme: {
                    type: 'object',
                    properties: {
                      primaryColor: {
                        title: '主题色',
                        type: 'string',
                        'x-decorator': 'FormItem',
                        'x-component': 'ColorInput',
                        'x-component-props': {
                          defaultValue: '#1890ff',
                        },
                      },
                    },
                  },
                }
              },
              "style-group": {
                type: 'void',
                'x-component': 'FormTab.TabPane',
                'x-component-props': {
                  tab: '样式',
                },
                properties: {
                  style: AllSchemas.CSSStyle,
                }
              }
            }
          },          
        },
      },
      defaultProps: {
        labelCol: 6,
        wrapperCol: 12,
      },
    }
  },
  designerLocales: AllLocales.Form,
})

Form.Resource = createResource({
  title: { 'zh-CN': '表单', 'en-US': 'Form' },
  icon: 'FormLayoutSource',
  elements: [
    {
      componentName: 'Field',
      props: {
        type: 'object',
        'x-component': 'Form',
      },
    },
  ],
})
